import { contratoApi } from '../../utils/api';
import { getListDataAction } from '../../utils/DataAction';

export const getAll = getListDataAction({
  dataName: 'FORMA_PAGO_CONTRATO',
  api: contratoApi,
  relUrl: 'getAllFormaPago',
});
